<template lang="html">

    <section class="buscador row-between">

        <div class="input-container-wrapper row-start">
        <div class="input-container">
            <select class="area" v-model="filtros.areafuncional">
                <option value="">Área funcional</option>
                <option v-for="tipo in dominiosorder.areafuncional" :value="tipo[0]">{{tipo[1]}}</option>
            </select>
        </div>

        <div class="input-container" v-if="hasExperiencias">
            <select class="categoria" v-model="filtros.experiencia">
                <option value="">Experiencia</option>
                <option v-for="tipo in dominiosorder.experiencia" :value="tipo[0]">{{tipo[1]}}</option>
            </select>
        </div>

        <div class="input-container">
            <select class="ubicacion" v-model="filtros.ubicacion">
                <option value="">Ubicación</option>
                <option v-for="ubicacion in ubicaciones" :value="ubicacion">{{ubicacion}}</option>
            </select>
        </div>

        <div class="input-container select" v-if="!hasExperiencias">
            <input type="text" id="palabrasclave" placeholder="Palabras de búsqueda"
                v-model="filtros.palabrasclave" :selected="!!filtros.palabrasclave">
        </div>
    </div>

        <router-link :to="$t('enlaces.ofertas')+link" class="btn skull">Buscar</router-link>

    </section>

</template>

<script lang="js">

    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'buscador-home',
        mounted(){
            if(this.ubicaciones.length == 0){
                this.requestFirstsOfertas();
            }
        },
        data(){
            return {
                filtros : {
                    areafuncional : '',
                    experiencia : '',
                    ubicacion : '',
                    palabrasclave : ''
                }
            }
        },
        methods : {
            ...mapActions(['requestFirstsOfertas'])  
        },
        computed : {
            ...mapGetters({
                dominios : 'getDominios',
                ubicaciones : 'getubicaciones',
                hasExperiencias : 'hasExperiencias'
            }),
            link(){
                let link = "?";
                for(let filtro in this.filtros){
                    if(!!this.filtros[filtro]){
                        link += '&'+filtro+'='+this.filtros[filtro];
                    }   
                }
                return link;
            },
            dominiosorder() {
                let dominios = new Object();
                if (!!this.dominios) {

                    let toorder = ['areafuncional', 'sectores','experiencia'];
                    toorder.forEach(e => {
                        let tipos = Object.entries(this.dominios[e]);
                        dominios[e] = tipos.sort(function (p1, p2) {
                            return (p1[1] < p2[1]) ? -1 : 1;
                        })
                    });

                }

                return dominios;
            },
        }
    }
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/parts/buscador-home.vue